
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'

import { SeIndicatorDotComponent } from './indicator-dot.component'

@NgModule({
  imports: [
	CommonModule
  ],
  declarations: [
    SeIndicatorDotComponent
  ],
  exports: [
    SeIndicatorDotComponent
  ],
})
export class SeIndicatorDotModule {}

export const SE_INDICATOR_DOT_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.indicatorDot`

